export enum EReminderOption {
  ALERTS = 0,
  PUSH = 1,
  EMAIL = 2,
}
